import { render } from "./ServProvided.vue?vue&type=template&id=1bf89c32&scoped=true"
import script from "./ServProvided.vue?vue&type=script&lang=js"
export * from "./ServProvided.vue?vue&type=script&lang=js"

import "./ServProvided.vue?vue&type=style&index=0&id=1bf89c32&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf89c32"]])

export default __exports__